import styled, { css, useTheme } from "styled-components";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";
import AntArrowLeftOutlined from "@ant-design/icons/ArrowLeftOutlined";
import AntArrowRightOutlined from "@ant-design/icons/ArrowRightOutlined";

interface ScrollButtonProps {
  onClick: () => void;
  disabled: boolean;
  isNextButton: boolean;
}

const ScrollButton = ({
  onClick,
  disabled,
  isNextButton,
}: ScrollButtonProps) => {
  const theme = useTheme();
  const props = {
    $disabled: disabled,
    onClick: onClick,
  };
  if (theme.isNewLook) {
    const Icon = isNextButton ? ChevronRight : ChevronLeft;
    return (
      <NewLookScrollButton {...props} $isNextButton={isNextButton}>
        <Icon size={16} strokeWidth={2} />
      </NewLookScrollButton>
    );
  }
  return (
    <>
      {isNextButton ? (
        <ArrowRightOutlined {...props} />
      ) : (
        <ArrowLeftOutlined {...props} />
      )}
    </>
  );
};

export default ScrollButton;

const arrowStyles = css<{ $disabled: boolean }>`
  color: ${(p) =>
    p.$disabled ? p.theme.colors.secondaryGrey : p.theme.colors.primaryBlue};
  font-size: ${(p) => p.theme.typography.fontSizes.L};
`;

const ArrowLeftOutlined = styled(AntArrowLeftOutlined)<{ $disabled: boolean }>`
  ${arrowStyles};
  margin-right: 16px;
`;
const ArrowRightOutlined = styled(AntArrowRightOutlined)<{
  $disabled: boolean;
}>`
  ${arrowStyles}
`;
const NewLookScrollButton = styled.span<{
  $disabled: boolean;
  $isNextButton: boolean;
}>`
  width: 30px;
  height: 30px;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(p) => p.theme.radii.pill}px;
  border: ${(p) => p.theme.borders.card};
  background: ${(p) => p.theme.colors.cardBgColor};
  color: ${(p) =>
    p.$disabled ? p.theme.colors.disabledText : p.theme.colors.primaryText};
  cursor: ${(p) => (p.$disabled ? "default" : "pointer")};
  margin-right: ${(p) => (p.$isNextButton ? 0 : 8)}px;
  transition: color 150ms, border-color 150ms;
  ${(p) =>
    !p.$disabled &&
    `
    &:hover {
      color: ${p.theme.colors.primaryBlue};
      border-color: ${p.theme.colors.primaryBlue};
    }
  `}
`;
